<template>
  <div class="fromStyle">
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      v-bind="formItemLayout"
    >
      <a-form-model-item label="用户" ref="user_id" prop="user_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.user_id"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, i) in userList"
            :key="i"
            >{{ element.role_names + "-" + element.user_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="身份" ref="role_type" prop="role_type">
        <a-radio-group v-model="form.role_type">
          <a-radio :value="1">项目总监</a-radio>
          <a-radio :value="2">项目经理</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="项目" ref="project_id" prop="project_id">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-model="form.project_id"
          @change="projectVal"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        label="管理门店"
        ref="shop_ids"
        prop="shop_ids"
        v-if="form.role_type == 2 && form.project_id != ''"
      >
        <a-select
          style="width:70%;margin-right:10px"
          placeholder="请选择门店"
          mode="multiple"
          show-search
          :filter-option="filterOption"
          v-model="form.shop_ids"
        >
          <a-select-option
            v-for="(item, i) in shopsLIst"
            :key="i"
            :value="item.id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit" @click="onSubmit"
          >提交</a-button
        >
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      rules: {
        user_id: [
          {
            required: true,
            message: "请选择用户",
            trigger: "change"
          }
        ],
        role_type: [
          {
            required: true,
            message: "请选择身份类型",
            trigger: "change"
          }
        ],
        project_id: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ],
        shop_ids: [
          {
            type: "array",
            required: true,
            message: "请选择项目",
            trigger: "change"
          }
        ]
      },
      form: {
        project_id: "",
        user_id: "",
        role_type: "",
        shop_ids: []
      },
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      userList: [],
      proList: [],
      shopsLIst: [],
      proArray: "multiple",
      bankList: []
    };
  },
  mounted() {
    this.getUser(); //获取用户
    this.getPro(); //获取项目
  },
  methods: {
    selectedAll(e) {
      this.form.shop_ids = [];
      if (e.target.checked) {
        this.shopsLIst.forEach(element => {
          this.form.shop_ids.push(element.id);
        });
      } else {
        this.form.shop_ids = [];
      }
    },
    projectVal(value, option) {
      // console.log(value)
      this.getShops(value);
    },
    getShops(proID) {
      let url =
        this.httpsBasic.url + this.httpsBasic.retail + "Retail_shop/lists";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: proID,
          per_page: 10000
        })
        .then(res => {
          if (res.data.code == 200) {
            this.shopsLIst = res.data.data.data;
            // console.log(this.shopsLIst);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUser() {
      let url =
        this.httpsBasic.url + this.httpsBasic.user + "User/employeeList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data;
          // console.log(this.userList);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onSubmit(e) {
      e.preventDefault();
      this.$refs.ruleForm.validate(valid => {
        // console.log(val);
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.retail +
            "Retail_role/addInsideRole";
          let params = {
            user_id: this.form.user_id,
            project_id: this.form.project_id,
            role_type: this.form.role_type,
            shop_ids: JSON.stringify(this.form.shop_ids),
            token: window.localStorage.getItem("xnwfPcToken")
          };
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.resetForm();
                this.$emit("hideInAdd", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
